export default __webpack_public_path__ + "static/media/tornado.ea56600a.png";